import { styled } from '@mui/material/styles';
import React from 'react';
import classNames from 'classnames';

const classes = {
  padding: 'GrowableContent-padding',
};

const Root = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flex: '1 1 0',
  overflowY: 'auto',
  '& > *': {
    flexShrink: 0,
  },
  [`&.${classes.padding}`]: {
    padding: theme.spacing(4, 2, 1, 2),
  },
}));

interface IProps {
  className?: string;
  children: React.ReactNode;
  padding?: boolean;
}

export const GrowableContent = (props: IProps) => {
  return (
    <Root
      className={classNames(props.className, {
        [classes.padding]: props.padding === true,
      })}
    >
      {props.children}
    </Root>
  );
};
